module.exports = __webpack_public_path__ + "static/media/sainsburyForOne.9012c9f1.csv";